import { Chip, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';
import { FSToggleButtonGroup } from '@/ui/components/button/FSToggleButtonGroup';
import { FSModal } from '@/ui/components/modal/FSModal';
import { translate } from '@/ui/i18n';

import { AssignExternalView } from './assign-external/AssignExternalView';
import { InviteSubmitData } from './assign-external/components/FormExternalInvite';

export type StakeholderItem = {
  sector: Sector;
  categories?: InviteCategory[];
  existingInvitations: ExternalInvitation[];
};

export function ModalStakeholders({
  open,
  onClose,
  items,
  onSubmitInvite,
}: {
  open: boolean;
  onClose: () => void;
  items: StakeholderItem[];
  onSubmitInvite: (data: InviteSubmitData) => void;
}) {
  return (
    <FSModal
      open={open}
      onClose={onClose}
      maxWidth={1200}
      showCloseButton={true}
    >
      <Stack direction={'column'} spacing={3}>
        <Typography sx={{ fontSize: '1.5rem', fontWeight: '900' }}>
          {translate('InviteExternalToFill.stakeholders')}
        </Typography>
        <TabsAndContent items={items} onSubmitInvite={onSubmitInvite} />
      </Stack>
    </FSModal>
  );
}

function TabsAndContent({
  items,
  onSubmitInvite,
}: {
  items: StakeholderItem[];
  onSubmitInvite: (data: InviteSubmitData) => void;
}) {
  const tabValues = prepareTabValue(items);
  const [currentTab, setCurrentTab] = useState<string>(tabValues[0].id);
  const item = items[parseInt(currentTab)];
  return (
    <>
      <FSToggleButtonGroup
        selectedValueId={currentTab}
        values={tabValues}
        onChange={(id) => setCurrentTab(id)}
      />
      <AssignExternalView
        sector={item.sector}
        categories={item.categories}
        existingInvitations={item.existingInvitations}
        onSubmitInvite={onSubmitInvite}
      />
    </>
  );
}

function prepareTabValue(
  items: StakeholderItem[],
): { id: string; value: React.ReactNode }[] {
  return items.map((x, index) => {
    const id = index.toString();
    const count = x.existingInvitations.length;
    const tabTitle = x.sector ? translate(`Sector.${x.sector}`) : '';
    const value = prepareToggleButtonValue(tabTitle, count);
    return { id, value };
  });
}

function prepareToggleButtonValue(text: string, count: number) {
  return (
    <Stack direction={'row'} spacing={1}>
      <Typography sx={{ fontSize: '1rem' }}>{text}</Typography>
      {count > 0 && <Chip label={count} size="small" />}
    </Stack>
  );
}
